'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import {
  type AlgoliaRecord,
  algoliaRecordAccessorGetFormattedPricePerUnit,
} from '../../../algolia'

type RecommendationProductPriceProps = {
  product: AlgoliaRecord
}

export const StoryblokProductBatteryPrice: FC<
  RecommendationProductPriceProps
> = ({ product }) => {
  const intl = useIntl()

  return (
    <div className="flex flex-col">
      <span className="flex flex-col">
        <span
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="min-h-[var(--type-scale-s-line-height)] whitespace-nowrap text-dark-primary-strong line-through"
        >
          {product.hide_discounts ? '' : product.listPriceFormatted}
        </span>
        <span
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="min-h-[calc(var(--type-scale-s-line-height))] whitespace-nowrap text-2xl font-bold leading-l text-dark-brand"
        >
          {product.priceFormatted}
        </span>
      </span>
      <span className="text-s text-dark-primary-strong">
        {algoliaRecordAccessorGetFormattedPricePerUnit(product, intl)}
      </span>
    </div>
  )
}
